import { v4 as uuidv4 } from 'uuid';

export default class MiteredSegment {
  id;
  _length = {}; /* NumberText */
  height; /* int */
  thickness = {}; /* NumberText */
  priority; /* int */


  constructor(length, height, thickness) {
    this.id = uuidv4();
    this._length = length;
    this.height = height;
    this.thickness = thickness;
    this.priority = 0;
  }

  set length(length) {
    this._length = length;
  }

  get length() {
    return this._length;
  }

  setPriority = (priority) => {
    this.priority = priority
  };

  exportSegment = () => ({
    height: this.height,
    thickness: this.thickness ? this.thickness.value : this.thickness,
    length: this.length.value,
  })
}
